import { z } from 'zod';
// Same flat/percentage shape the booking wizard stages, so the totals engine reads a discount identically here and at booking.
export const salesOrderAdjustmentDiscountTypeSchema = z.enum(['flat', 'percentage']);
//# sourceMappingURL=sales-order-adjustment-discount-type-schema.js.map